// Knihovna pro globalni funkce

export function makeID(user) {
  //let vysledek = user.email.replace("@", "(at)").replace(/\./g, "(tecka)");
  let vysledek = user.uid;
  //console.log("Hledam" + vysledek);
  return vysledek;
}

export function formDate(datum) {
  //var datum = new Date(vstup);
  console.log(datum.toISOString());
  var d = datum.toISOString().slice(0, 10);
  var t = datum.toISOString().slice(11, 16);
  console.log("D:" + d + " T:" + t);

  return d + " " + t;
}

// export default () => {
//   makeID: makeID;
// };
